import React, {useState} from "react"
import {useDispatch, useSelector} from "react-redux"
import {Button, Card, InputGroup} from "@blueprintjs/core"
import _ from "lodash"
import {
    getContext,
    selectDisplayDataContextTemplates,
} from "../../redux/refdb.selector"
import {generalSettingsActions} from "../../../settings/redux/actions/settings.actions"
import {ContextTemplate} from "../../../settings/redux/reducers/settings.state"
import {setDisplayDataContextAction} from "../../redux/refdb.actions"

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface SettingsCardProps {}

const settingsLimit = 10

const SettingsCard: React.FC<SettingsCardProps> = () => {
    const dispatch = useDispatch()
    const context = useSelector(getContext)
    const contextTemplates = useSelector(selectDisplayDataContextTemplates)
    const [newTemplateName, setNewTemplateName] = useState("")

    const onLoadTemplate = (template: ContextTemplate) => {
        dispatch(setDisplayDataContextAction(template.context))
    }

    const onSaveTemplate = () => {
        dispatch(
            generalSettingsActions.updateSetting<ContextTemplate[]>(
                "contextTemplates",
                [...contextTemplates, {name: newTemplateName, context}]
            )
        )
        setNewTemplateName("")
    }

    const onRemoveTemplate = (template: ContextTemplate) => {
        dispatch(
            generalSettingsActions.updateSetting<ContextTemplate[]>(
                "contextTemplates",
                [...contextTemplates.filter((t) => t.name !== template.name)]
            )
        )
    }

    const onTemplateNameChange = (event: React.FormEvent<HTMLElement>) => {
        setNewTemplateName((event.target as HTMLInputElement).value)
    }

    return (
        <Card>
            <div
                style={{
                    marginBottom: "5px",
                    // maxHeight: "200px", // could be used if scroll is needed
                    // overflowY: "scroll",
                }}
            >
                {contextTemplates.map((template) => (
                    // eslint-disable-next-line react/no-array-index-key
                    <div className="CardRow" key={template.name}>
                        <Button
                            minimal
                            alignText="left"
                            style={{width: "310px", marginRight: "1em"}}
                            text={template.name}
                            onClick={() => onLoadTemplate(template)}
                        />
                        <Button
                            minimal
                            icon="trash"
                            onClick={() => onRemoveTemplate(template)}
                            title="Remove"
                        />
                    </div>
                ))}
            </div>
            {contextTemplates.length < settingsLimit && (
                <div className="CardRow">
                    <InputGroup
                        style={{width: "310px", marginRight: "1em"}}
                        placeholder="Enter description"
                        maxLength={25}
                        type="text"
                        value={newTemplateName}
                        onChange={onTemplateNameChange}
                        disabled={
                            _.isEmpty(context.material) &&
                            _.isEmpty(context.species)
                        }
                    />
                    <Button
                        minimal
                        icon="floppy-disk"
                        onClick={onSaveTemplate}
                        disabled={
                            newTemplateName.length < 3 ||
                            !context.matrixType ||
                            contextTemplates.some(
                                (ct) => ct.name === newTemplateName
                            )
                        }
                        title="Add"
                    />
                </div>
            )}
        </Card>
    )
}

export default SettingsCard
